import { useQuery } from 'urql';
import { graphql, type ResultOf, readFragment } from '@/gql/graphql';

const UseConfigFragment = graphql(/* GraphQL */ `
  fragment UseConfig on configuration {
    kind
    value
  }
`);

type LocalConfig = Partial<
  Record<
    ResultOf<typeof UseConfigFragment>['kind'],
    ResultOf<typeof UseConfigFragment>['value']
  >
>;

const GetConfig = graphql(/* GraphQL */ `
  query GetConfig @cached(ttl: 300) {
    configuration {
      ...UseConfig
    }
  }
`, [UseConfigFragment]);

export default function useConfig() {
  const [{ data }] = useQuery({ query: GetConfig });
  const fragment = readFragment(UseConfigFragment, data?.configuration || []);

  if (data?.configuration) {
    const configData = fragment.reduce(
      (acc, config: ResultOf<typeof UseConfigFragment>) => {
        acc[config.kind] = config.value;
        return acc;
      },
      {} as LocalConfig,
    );

    return configData;
  }

  return {};
}
